import { apiSlice } from "./ApiSlice";

const SignupAPISlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        signup: builder.mutation({
            query: credentials => {
              
                for (let [key, value] of credentials.entries()) {
                   
                  }
                return {
                    url: '/api/Account/Invite',
                    method: 'POST',
                    body: credentials,
                }
            }
        })
    })
})

export const { useSignupMutation } = SignupAPISlice;